import request from "./request.service";

export async function getGeneralInfo(consumerId = "", version = "v4") {
  try {
    const res = await request(
      `/factory/general?consumer_id=${consumerId}&version=${version}`,
      "GET",
      {}
    );
    return res.data;
  } catch (err) {
    throw err;
  }
}
export async function getSpend(consumerId, offset, limit, version = "v4") {
  try {
    const res = await request(
      `/factory/spend?consumer_id=${consumerId}&version=${version}&limit=${limit}&offset=${offset}`,
      "GET",
      {}
    );
    return res.data;
  } catch (err) {
    throw err;
  }
}
export async function getCollect(consumerId, offset, limit, version = "v4") {
  try {
    const res = await request(
      `/factory/collect?consumer_id=${consumerId}&version=${version}&limit=${limit}&offset=${offset}`,
      "GET",
      {}
    );
    return res.data;
  } catch (err) {
    throw err;
  }
}
export async function getPurchase(consumerId, offset, limit, version = "v4") {
  try {
    const res = await request(
      `/factory/purchase?consumer_id=${consumerId}&version=${version}&limit=${limit}&offset=${offset}`,
      "GET",
      {}
    );
    return res.data;
  } catch (err) {
    throw err;
  }
}
export async function giveToken(data) {
  try {
    const res = await request(`/factory/giveToken`, "POST", { ...data });
    return res.data;
  } catch (err) {
    throw err;
  }
}
